/* @flow strict */

import _ from 'lodash';

const validateFbInfo = (data: {}, scrollCb: (HTMLElement) => void): boolean => {
  let isValid = true;

  const fbTitleEl = document.querySelector('#fbTitle');
  const fbDescEl = document.querySelector('#fbDesc');

  let invalidEl = null;

  if (!_.size(data.description)) {
    invalidEl = fbDescEl;
    isValid = false;
  }

  if (!_.size(data.title)) {
    invalidEl = fbTitleEl;
    isValid = false;
  }

  if (scrollCb) {
    scrollCb(invalidEl);
  }

  return isValid;
};

export default validateFbInfo;
